import styled, { css, keyframes } from 'styled-components';

const blink = keyframes`
  from {
    opacity: 0%;
  }

  to {
    opacity: 100%;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  transition: all 0.3s;

  border-width: 0.1rem;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.3);
  border-radius: 0.2rem;

  padding: 0.5rem;
`;

const wrapperHeaderModifiers = {
  colors: (mod) => css`
    color: ${mod === 'r' ? '#008000' : '#FF0000'};
  `,
  connect: (connect) =>
    !connect &&
    css`
      color: #ff8c00;
    `,
};

export const WrapperHeader = styled.header`
  ${({ mod, connected }) => css`
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-bottom: -1rem;

    p {
      font-weight: 1.2rem;
      font-weight: 700;

      ${wrapperHeaderModifiers.colors(mod)}
      ${wrapperHeaderModifiers.connect(connected)}
    }
  `}
`;

export const WrapperMain = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;

  margin-bottom: 0.5rem;
`;

const wrapperInputModifiers = {
  error: (err) =>
    !!err &&
    css`
      border-color: #ff0000;
      color: #ff0000;

      svg {
        animation: ${blink} 0.75s linear infinite;
      }

      input {
        border-color: #ff0000;
        color: #ff0000;
      }
    `,
  side: (pos = 'E') => css`
    flex-direction: ${pos === 'E' ? 'row' : 'row-reverse'};

    input {
      margin-right: ${pos === 'E' ? '0' : '0.5rem'};
      margin-left: ${pos === 'E' ? '0.5rem' : '0'};
    }
  `,
};

export const WrapperInput = styled.div`
  ${({ error, side }) => css`
    border: 1px solid #666;
    border-radius: 10px;

    font-size: 1.2rem;
    font-weight: 400;

    margin: 0.5rem 0;
    padding: 0.3rem;

    width: 100%;

    display: flex;
    align-items: center;

    color: #666;

    svg {
      font-size: 2rem;
    }

    input {
      flex: 1;

      border: 0;

      font-size: 1.2rem;

      background-color: transparent;
    }

    ${wrapperInputModifiers.error(error)}
    ${wrapperInputModifiers.side(side)}
  `}
`;

export const WrapperTruck = styled.div`
  border-width: 0.1rem;
  border-style: solid;
  border-radius: 0.2rem;
  border-color: rgba(0, 0, 0, 0.3);

  margin-top: 1rem;

  padding: 1rem;

  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%),
      0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%);
  }
`;
